import { FC, useCallback, useEffect, useRef, useState } from "react";
import { pieChartObject } from "./types";
import { PIE_CHART_DRILLDOWN_OPTIONS } from "src/constants/highCharts";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown";




const DrillDownPieChart: FC<pieChartObject> = ({ pieChartObject, title }): JSX.Element => {
  const chartRef = useRef<HighchartsReact.RefObject>(null)
  
  //console.log("pieChartObject....",pieChartObject)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [data, setData] = useState({});
  Drilldown(Highcharts);


  // eslint-disable-next-line react-hooks/rules-of-hooks
  const populatePieChart = useCallback(() => {
    const topPayorOptions = {
      ...PIE_CHART_DRILLDOWN_OPTIONS,
      series: pieChartObject && pieChartObject.series ? 
        { 
          ...pieChartObject.series[0],
          name: "All ICD Codes",
          data: pieChartObject.series[0].data.map((value) => ({
            tooltip: value.name.split("-")[0].trim(), y: value.y,
            drilldown: value.drilldown, name: value.name, value: value.percentage
          }))
        } : [],
      drilldown: pieChartObject && pieChartObject.drilldown && pieChartObject.drilldown.series ? 
        {
          series: pieChartObject.drilldown.series.map((value) => ({
            plotOptions: PIE_CHART_DRILLDOWN_OPTIONS.plotOptions?.pie?.dataLabels,
            ...value,
            name: value.name,
            data: value.data.map((val) => ({
              name: val[0], y: val[1],
              value: val[2], tooltip: val[0],
            }))
          }))
        }
        : [],
    };
    setData(topPayorOptions);

    if (chartRef.current && chartRef.current.chart) chartRef.current.chart.redraw()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pieChartObject]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    populatePieChart();
  }, [populatePieChart]);

  return (
    <div>
        <div className="card">
          <div className="card-header">
            <h4 className="m-0">{title}</h4>
          </div>
          <div className="card-body">
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={data} />
          </div>
        </div>
    </div>
  );
};

export default DrillDownPieChart;